import { config } from '~shared/config';

import { initLogs } from '@breezeventures/web-ph-telemetry/init-logs';
import { initMetrics } from '@breezeventures/web-ph-telemetry/init-metrics';
import { metrics } from '@opentelemetry/api';
import { logs } from '@opentelemetry/api-logs';

const source = {
  serviceName: 'web-app-merchant-portal',
  serviceVersion: config.version,
  collectorHost:
    config.environment === 'local'
      ? 'https://portal-api-test.breezeventures.io/otel'
      : `${config.apiHost}/otel`,
  env: config.environment,
};

const { logger } = config.isTelemetryEnabled
  ? initLogs({
      ...source,
      // first-party API hosts allowed to receive the outgoing B3 trace headers
      propagateTraceHeaderCorsUrls: [/portal-api/],
      // analytics and telemetry endpoints must not be traced/instrumented
      ignoreUrls: [/collect/, /\/telemetry/, /amplitude/, /clarity/, /sentry/],
      traces: false,
    })
  : { logger: logs.getLogger('noop') };

const { meter } = config.isTelemetryEnabled
  ? initMetrics(source)
  : { meter: metrics.getMeter('noop') };

export { meter, logger };
